/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AuthPostChangePassword = {
  id: 'authentication.change-password.post',
  tag: 'Authentication',
  summary: 'Change password',
  description: 'Change users password',
  method: 'post',
  route: () => `/authentication/change-password`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            token: ZodTypes.TrimmedString.min(1),
            password: ZodTypes.Password,
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.object({}).optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
